import React from 'react';
import { UNDO_BUTTON, REDO_BUTTON, UNDO_CHANGES_GROUP_RANK, UNDO_CHANGES_GROUP, REDO_CHANGES_GROUP_RANK, REDO_CHANGES_GROUP, TRACK_CHANGES_SECTION, TRACK_CHANGES_SECTION_RANK } from '@atlaskit/editor-common/toolbar';
import { Show, ToolbarButtonGroup } from '@atlaskit/editor-toolbar';
import { RedoButton } from './RedoButton';
import { UndoButton } from './UndoButton';
export var getToolbarComponents = function getToolbarComponents(api) {
  var _api$toolbar;
  var breakpointPreset = api === null || api === void 0 || (_api$toolbar = api.toolbar) === null || _api$toolbar === void 0 ? void 0 : _api$toolbar.actions.getBreakpointPreset();
  return [{
    type: UNDO_CHANGES_GROUP.type,
    key: UNDO_CHANGES_GROUP.key,
    parents: [{
      type: TRACK_CHANGES_SECTION.type,
      key: TRACK_CHANGES_SECTION.key,
      rank: TRACK_CHANGES_SECTION_RANK[UNDO_CHANGES_GROUP.key]
    }],
    component: function component(_ref) {
      var children = _ref.children;
      return breakpointPreset === 'jsm-comment' ? /*#__PURE__*/React.createElement(Show, {
        above: "lg"
      }, /*#__PURE__*/React.createElement(ToolbarButtonGroup, null, children)) : /*#__PURE__*/React.createElement(ToolbarButtonGroup, null, children);
    }
  }, {
    type: UNDO_BUTTON.type,
    key: UNDO_BUTTON.key,
    parents: [{
      type: UNDO_CHANGES_GROUP.type,
      key: UNDO_CHANGES_GROUP.key,
      rank: UNDO_CHANGES_GROUP_RANK[UNDO_BUTTON.key]
    }],
    component: function component() {
      return /*#__PURE__*/React.createElement(UndoButton, {
        api: api
      });
    }
  }, {
    type: REDO_CHANGES_GROUP.type,
    key: REDO_CHANGES_GROUP.key,
    parents: [{
      type: TRACK_CHANGES_SECTION.type,
      key: TRACK_CHANGES_SECTION.key,
      rank: TRACK_CHANGES_SECTION_RANK[REDO_CHANGES_GROUP.key]
    }],
    component: function component(_ref2) {
      var children = _ref2.children;
      return breakpointPreset === 'jsm-comment' ? /*#__PURE__*/React.createElement(Show, {
        above: "lg"
      }, /*#__PURE__*/React.createElement(ToolbarButtonGroup, null, children)) : /*#__PURE__*/React.createElement(ToolbarButtonGroup, null, children);
    }
  }, {
    type: REDO_BUTTON.type,
    key: REDO_BUTTON.key,
    parents: [{
      type: REDO_CHANGES_GROUP.type,
      key: REDO_CHANGES_GROUP.key,
      rank: REDO_CHANGES_GROUP_RANK[REDO_BUTTON.key]
    }],
    component: function component() {
      return /*#__PURE__*/React.createElement(RedoButton, {
        api: api
      });
    }
  }];
};